import React from 'react';
import {
	BasicButton,
	TextInput,
} from '../../UI';
import { getSecondary } from '../../styles/colors';
import FormRootLayout from './FormRootLayout';


const ConfigHome = ({
	portal,
	updateState,
	translate,
}) => {
	const [localState, setLocalState] = React.useState(portal);

	const renderForm = () => <div>
		{/* HEADER */}
		<div>
			<h3 style={{ fontSize: '1.2rem' }}>HEADER</h3> {/* TRADUCCION */}
		</div>
		{/* LOGO */}
		<div style={{
			marginTop: '1em',
			display: 'flex',
			marginBottom: '1em',
			alignItems: 'center'
		}}>
			{/* URL EDIT */}
			<TextInput
				styles={{ marginRight: '1em' }}
				floatingText={'Logo'} // TRADUCCION
				value={localState?.config?.header?.logo}
				onChange={event => {
					event.preventDefault();
					setLocalState({
						...localState,
						config: {
							...localState.config,
							header: {
								...localState.config.header,
								logo: event.target.value
							}
						}
					});
				}
				}
			/>
			{/* URL LINK */}
			<div style={{
				marginTop: '1em',
				width: 'max-content',
			}}>
				<a
					style={{
						marginRight: '0.5em',
						color: 'black',
						fontWeight: 'bold',
						width: 'max-content'
					}}
					rel="noreferrer"
					href={`${localState?.config?.header?.logo}`}
					target="_blank"
				>
					Previsualizar{/* TRADUCCION */}
				</a>
			</div>
		</div>
		{/* BG IMG NAVBAR */}
		<div style={{
			marginTop: '1em',
			display: 'flex',
			marginBottom: '1em',
			alignItems: 'center'
		}}>
			{/* URL EDIT */}
			<TextInput
				styles={{ marginRight: '1em' }}
				floatingText={'Imagen background de la barra de navegacion'} // TRADUCCION
				value={localState?.config?.header?.bgImage}
				onChange={event => {
					event.preventDefault();
					setLocalState({
						...localState,
						config: {
							...localState.config,
							header: {
								...localState.config.header,
								bgImage: event.target.value
							}
						}
					});
				}
				}
			/>
			{/* URL LINK */}
			<div style={{
				marginTop: '1em',
				width: 'max-content',
			}}>
				<a
					style={{
						marginRight: '0.5em',
						color: 'black',
						fontWeight: 'bold',
						width: 'max-content'
					}}
					rel="noreferrer"
					href={`${localState?.config?.header?.bgImage}`}
					target="_blank"
				>
					Previsualizar{/* TRADUCCION */}
				</a>
			</div>
		</div>
		{/* HOME */}
		<div>
			<h3 style={{ fontSize: '1.2rem' }}>HOME</h3> {/* TRADUCCION */}
		</div>
		{/* BG IMG HOME */}
		<div style={{
			marginTop: '1em',
			display: 'flex',
			marginBottom: '1em',
			alignItems: 'center'
		}}>
			{/* URL EDIT */}
			<TextInput
				styles={{ marginRight: '1em' }}
				floatingText={'Imagen background de Home'} // TRADUCCION
				value={localState?.config?.home?.bgImage}
				onChange={event => {
					event.preventDefault();
					setLocalState({
						...localState,
						config: {
							...localState.config,
							home: {
								...localState.config.home,
								bgImage: event.target.value
							}
						}
					});
				}
				}
			/>
			{/* URL LINK */}
			<div style={{
				marginTop: '1em',
				width: 'max-content',
			}}>
				<a
					style={{
						marginRight: '0.5em',
						color: 'black',
						fontWeight: 'bold',
						width: 'max-content'
					}}
					rel="noreferrer"
					href={`${localState?.config?.home?.bgImage}`}
					target="_blank"
				>
					Previsualizar{/* TRADUCCION */}
				</a>
			</div>
		</div>
		{/* FOOTER */}
		<div>
			<h3 style={{ fontSize: '1.2rem' }}>FOOTER</h3>{/* TRADUCCION */}
		</div>
		{/* LEGAL WARNING */}
		<div style={{
			marginTop: '1em',
			display: 'flex',
			marginBottom: '1em',
			alignItems: 'center'
		}}>
			{/* URL EDIT */}
			<TextInput
				styles={{ marginRight: '1em' }}
				floatingText={'URL Aviso Legal'} // TRADUCCION
				value={localState?.config?.footer?.links?.legalWarning?.value}
				onChange={event => {
					event.preventDefault();
					setLocalState({
						...localState,
						config: {
							...localState.config,
							footer: {
								...localState.config.footer,
								links: {
									...localState.config.footer.links,
									legalWarning: {
										...localState.config.footer.links.legalWarning,
										value: event.target.value
									}
								}
							}
						}
					});
				}
				}
			/>
			{/* URL LINK */}
			<div style={{
				marginTop: '1em',
				width: 'max-content',
			}}>
				<a
					style={{
						marginRight: '0.5em',
						color: 'black',
						fontWeight: 'bold',
						width: 'max-content'
					}}
					rel="noreferrer"
					href={`${localState?.config?.footer?.links?.legalWarning?.value}`}
					target="_blank"
				>
					Previsualizar{/* TRADUCCION */}
				</a>
			</div>
		</div>
		{/* PRIVACY POLICY */}
		<div style={{
			marginTop: '1em',
			display: 'flex',
			marginBottom: '1em',
			alignItems: 'center'
		}}>
			{/* URL EDIT */}
			<TextInput
				styles={{ marginRight: '1em' }}
				floatingText={'URL Politica Privacidad'} // TRADUCCION
				value={localState?.config?.footer?.links?.privacyPolicy?.value}
				onChange={event => {
					event.preventDefault();
					setLocalState({
						...localState,
						config: {
							...localState.config,
							footer: {
								...localState.config.footer,
								links: {
									...localState.config.footer.links,
									privacyPolicy: {
										...localState.config.footer.links.privacyPolicy,
										value: event.target.value
									}
								}
							}
						}
					});
				}
				}
			/>
			{/* URL LINK */}
			<div style={{
				marginTop: '1em',
				width: 'max-content',
			}}>
				<a
					style={{
						marginRight: '0.5em',
						color: 'black',
						fontWeight: 'bold',
						width: 'max-content'
					}}
					rel="noreferrer"
					href={`${localState?.config?.footer?.links?.privacyPolicy?.value}`}
					target="_blank"
				>
					Previsualizar{/* TRADUCCION */}
				</a>
			</div>
		</div>
		{/* SUPPORT */}
		<div style={{
			marginTop: '1em',
			display: 'flex',
			marginBottom: '1em',
			alignItems: 'center'
		}}>
			{/* URL EDIT */}
			<TextInput
				styles={{ marginRight: '1em' }}
				floatingText={'URL Soporte'} // TRADUCCION
				value={localState?.config?.footer?.links?.support?.value}
				onChange={event => {
					event.preventDefault();
					setLocalState({
						...localState,
						config: {
							...localState.config,
							footer: {
								...localState.config.footer,
								links: {
									...localState.config.footer.links,
									support: {
										...localState.config.footer.links.support,
										value: event.target.value
									}
								}
							}
						}
					});
				}
				}
			/>
			{/* URL LINK */}
			<div style={{
				marginTop: '1em',
				width: 'max-content',
			}}>
				<a
					style={{
						marginRight: '0.5em',
						color: 'black',
						fontWeight: 'bold',
						width: 'max-content'
					}}
					rel="noreferrer"
					href={`${localState?.config?.footer?.links?.support?.value}`}
					target="_blank"
				>
					Previsualizar{/* TRADUCCION */}
				</a>
			</div>
		</div>
		{/* TERMS AND CONDITIONS */}
		<div style={{
			marginTop: '1em',
			display: 'flex',
			marginBottom: '1em',
			alignItems: 'center'
		}}>
			{/* URL EDIT */}
			<TextInput
				styles={{ marginRight: '1em' }}
				floatingText={'URL Terminos y Condiciones'} // TRADUCCION
				value={localState?.config?.footer?.links?.termsConditions?.value}
				onChange={event => {
					event.preventDefault();
					setLocalState({
						...localState,
						config: {
							...localState.config,
							footer: {
								...localState.config.footer,
								links: {
									...localState.config.footer.links,
									termsConditions: {
										...localState.config.footer.links.termsConditions,
										value: event.target.value
									}
								}
							}
						}
					});
				}
				}
			/>
			{/* URL LINK */}
			<div style={{
				marginTop: '1em',
				width: 'max-content',
			}}>
				<a
					style={{
						marginRight: '0.5em',
						color: 'black',
						fontWeight: 'bold',
						width: 'max-content'
					}}
					rel="noreferrer"
					href={`${localState?.config?.footer?.links?.termsConditions?.value}`}
					target="_blank"
				>
					Previsualizar{/* TRADUCCION */}
				</a>
			</div>
		</div>
	</div>;

	return <FormRootLayout
		form={renderForm()}
		button={
			<BasicButton
				color='white'
				text={translate.save}
				onClick={() => {
					updateState({
						...localState.config,
					});
				}}
				backgroundColor={{
					backgroundColor: getSecondary(),
					border: `1px solid ${getSecondary()}`,
					boxShadow: 'none',
					color: 'white',
					fontWeight: 'bold'
				}}
			/>
		}
	/>;
};

export default ConfigHome;
